export const TableSubtext = (props: { text: string }) => {
    return (
        <p className="mt-2 text-[#b9b9c3]">{props.text}
        </p>
    )
}